import { initGlobalMotion } from './core/motion';
import { initAnalytics } from './core/analytics';
import { initNav, initAssistant, initLanguageDropdown, initCookieBanner, initCulturePersistence, initResourceFilter } from './core/common';
import { initCustomSelects } from './core/customSelect';
import { initServices, initServicesHero } from './pages/services';
import { initBlogIndex, initBlogList, initBlogPost } from './pages/blog';
import { initGlobalBackground } from './core/background';
import { initAiPathway } from './pages/aiml';
import { initAutomationsLogic, initGearMotion } from './pages/automations';
import { initCloudTerminal, initCloudNodes } from './pages/cloud';
import { initConsultingLens, initConsultingTimeline } from './pages/consulting';
import { initDevelopmentForge, initQualityGates } from './pages/development';
import { initDevOpsPipeline } from './pages/devops';
import { initMentoringGrowth, initProgressionPath } from './pages/mentoring';
import { initSecurityScanner, initSecurityShield } from './pages/security';
import { initStartupGauge, initLaunchpadTimeline } from './pages/startup';
import { initSystemDesignGrid, initC4Modeling } from './pages/systemdesign';
import { initPhilosophyStory, initCultureDojo, initCompanySynthesis } from './pages/about';
import { initTaiikuRhythm, initNakamaNetwork, initBankaGold, initProductGalleries, initKaizenDoScreens } from './pages/products';
import { initBooking, initContact, initApplication } from './pages/misc';
import { initHomeHero } from './pages/home';
import { initCraftCaseHeroInteractivity } from './pages/craftCaseStudy';
import { initOurCraftsPage } from './pages/ourCrafts';

function bootstrap(): void {
    initGlobalBackground('bg-nodes');
    initNav();
    initAssistant();
    initLanguageDropdown();
    initCookieBanner();
    initAnalytics();
    initCulturePersistence();
    initCustomSelects();
    initResourceFilter();
    initGlobalMotion();

    // Page-specific
    if (document.getElementById('home')) { initHomeHero(); }
    if (document.querySelector('.aiml-page')) { initAiPathway(); }
    if (document.querySelector('.automations-page')) { initAutomationsLogic(); initGearMotion(); }
    if (document.querySelector('.cloud-page')) { initCloudTerminal(); initCloudNodes(); }
    if (document.querySelector('.consulting-page')) { initConsultingLens(); initConsultingTimeline(); }
    if (document.querySelector('.dev-page')) { initDevelopmentForge(); initQualityGates(); }
    if (document.querySelector('.devops-page')) { initDevOpsPipeline(); }
    if (document.querySelector('.mentoring-page')) { initMentoringGrowth(); initProgressionPath(); }
    if (document.querySelector('.security-page')) { initSecurityScanner(); initSecurityShield(); }
    if (document.querySelector('.startup-page')) { initStartupGauge(); initLaunchpadTimeline(); }
    if (document.querySelector('.sysdesign-page')) { initSystemDesignGrid(); initC4Modeling(); }
    
    if (document.querySelector('.philosophy-page')) initPhilosophyStory();
    if (document.querySelector('.culture-page')) initCultureDojo();
    if (document.querySelector('.company-page')) initCompanySynthesis();

    if (document.querySelector('.taiiku-page')) initTaiikuRhythm();
    if (document.querySelector('.nakama-page')) initNakamaNetwork();
    if (document.querySelector('.banka-page')) initBankaGold();
    if (document.querySelector('.kaizen-do-page')) initKaizenDoScreens();
    if (document.querySelector('[data-prod-gallery]')) initProductGalleries();
    if (document.querySelector('.our-crafts-page')) initOurCraftsPage();
    if (document.querySelector('.craft-case-page')) initCraftCaseHeroInteractivity();

    if (document.querySelector('.booking-page')) initBooking();
    if (document.getElementById('contact-form')) initContact();
    if (document.getElementById('application-form')) initApplication();
    if (document.getElementById('servicesPage')) { initServices(); initServicesHero(); }

    initBlogIndex();
    initBlogList();
    initBlogPost();
}

document.addEventListener('DOMContentLoaded', bootstrap);
